import { Apollo, gql } from 'apollo-angular';
import { Injectable } from '@angular/core';
import { combineLatest } from 'rxjs';
import { Filter } from 'src/app/core/models/filter';
import { pluck } from 'rxjs/operators';

const getSupplyFavoritesSubscription = gql`query supply_favorites($limit: Int, $offset: Int) {
  supply_favorites(where:{supply:{product_status: {_eq: "ACTIVE"}}},limit: $limit, offset: $offset) {
    id
    supply_id
    supply_variant_id
    created_at
    updated_at
    supply{
        id
      created_at
      updated_at
      name
      alt_text_of_image
      details
      image
      is_featured
      more_images
      page_title
      seo_metadata
      short_id
      short_info
      sku
      specifications
      status
      product_status
      supply_brand_id
      supply_brand {
        id
        name
      }
      supply_category_id
      supply_category {
        id
        name
      }
      supply_sub_category_id
      supply_sub_category {
        id
        name
      }
      video

        dental_suppliers_id
        dental_supplier{
          id
          name
          logo
          business_name
        }
        j_supply_deals_supplies(where:{
          supply_deal: {
            start:{ _lte: "now()" },
            end: { _gte: "now()" }
          }
        },
        order_by: { created_at: desc }
        ) {
          id
          supply_id
          supply_deal_id
          supply_deal {
            id
            name
            image
            type
          }
        }
      }
      supply_variant{
        id
        created_at
        updated_at
        actual_price
        attributes
        available_stock
        color
        details
        image
        make_default
        more_images
        price_unit
        selling_price
        specifications
        status
        stock_unit
        supply_id
        title
        video
        supply_reviews_aggregate {
          aggregate {
            count
            sum{
              rating
            }
          }
        }
      }
  }
}`;

const getSupplyFavoritesAggregateSubscription = gql`query supply_favorites_aggregate{
  supply_favorites_aggregate(where: {supply:{product_status: {_eq: "ACTIVE"}}}){
    aggregate {
      count
    }
  }
}`;


@Injectable({
  providedIn: 'root'
})
export class GetSupplyFavoritesService {

  constructor(private apollo: Apollo) { }

  getSupplyFavorites(filter: Filter){
    return combineLatest([
      this.apollo.use('external').query({
       query: getSupplyFavoritesSubscription,
       fetchPolicy: "network-only",
       variables: {
         limit: filter.limit,
         offset: filter.offset
       }
      }).pipe(pluck('data', 'supply_favorites')),
      this.apollo.use('external').query({
        query: getSupplyFavoritesAggregateSubscription,
        fetchPolicy: "network-only"
      }).pipe(pluck('data', 'supply_favorites_aggregate', 'aggregate', 'count'))
    ]);
  }
}


